<template>
  <div id="appCapsule">
    <div class="section mt-2">
      <div class="quick-loan-form">
        <form
          method="POST"
          id="quickLoanForm"
          class="dyno-form"
          autocomplete="off"
        >
          <div class="form-group">
            <div class="mt-pop-desc-txt">
              You can apply for a Rockland Vault grant. Fill the form below to
              get started.
            </div>
          </div>

          <div class="card app-loans-card">
            <div class="card-body">
              <div class="form-group">
                <label class="mt-form-label">Select Account</label><br />

                <select
                  v-model="accountId"
                  class="form-control"
                  style="width: 100%; height: 45px;"
                >
                  <option
                    v-for="account in accounts"
                    :key="account.id"
                    v-if="account.isActive == 1"
                    :value="account.id"
                    :data-account_number="account.number"
                    >{{ account.type }} ****
                    {{ account.number.slice(-4) }}
                    {{ account.currency.symbol }}{{ account.balance }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label class="mt-form-label">Type of grant</label><br />
                <select
                  v-model="description"
                  class="form-control"
                  style="width: 100%; height: 45px;"
                >
                  <option value="Federal Government Grant"
                    >Federal Government Grant</option
                  >
                  <option value="Educational Grant">Educational Grant</option>
                  <option value="Foundation Grant">Foundation Grant</option>
                </select>
              </div>

              <div class="form-group">
                <label class="mt-form-label">Grant Amount</label><br />
                <input type="text" class="form-control" v-model="amount" />
              </div>

              <div class="form-group">
                <label class="mt-form-label">SSN (US Residents Only)</label
                ><br />
                <input type="text" class="form-control" v-model="ssn" />
              </div>

              <div class="form-group">
                <label class="mt-form-label">Upload Passport</label><br />
                <input
                  @change="onPassportChanged"
                  ref="file"
                  type="file"
                  class="form-control"
                />
              </div>

              <div class="form-group">
                <label class="mt-form-label"
                  >Upload documents (About yourself or organization)</label
                ><br />
                <input
                  @change="onDocumentChanged"
                  ref="file1"
                  type="file"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="form-group submit">
            <button
              @click.prevent="requestGrant"
              :disabled="processing"
              type="submit"
              name="add_account"
              class="btn btn-primary btn-block btn-lg link-loader"
            >
              {{ processing ? "Processing..." : "Request Grant" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
  data() {
    return {
      loans: [],
      amount: 0,
      expiry: "",
      description: "Student Loan",
      processing: false,
      accountId: null,
      accounts: [],
      passport: "",
      document: "",
      ssn: "",
    };
  },
  methods: {
    onPassportChanged() {
      var uploadedFile = this.$refs.file.files[0];
      this.passport = uploadedFile;
      return;
    },
    onDocumentChanged() {
      var uploadedFile = this.$refs.file1.files[0];
      this.document = uploadedFile;
      return;
    },
    showModal() {
      $("#modal-invest").modal("show");
    },
    async requestGrant() {
      if (
        !this.amount ||
        !this.description ||
        !this.document ||
        !this.document ||
        !this.accountId
      ) {
        return toast.fire({
          type: "error",
          title: "Ensure all fields are filled",
        });
      }
      this.processing = true;

      var formData = new FormData();
      formData.append("document", this.document);
      formData.append("passport", this.passport);
      formData.append("account", this.accountId);
      formData.append("description", this.description);
      formData.append("amount", this.amount);
      formData.append("ssn", this.ssn);
      formData.append("type", "grant");
      try {
        await AR.userLoanRequest(formData);
        $("#modal-invest").modal("hide");
        this.processing = false;
        toast.fire({
          type: "success",
          title: "Grant application submitted successfully",
        });
        setTimeout(() => {
          window.location.href = "/m/overview";
        }, 1000);
      } catch (error) {
        this.processing = false;

        console.log(error);
      }
    },
  },
  created() {
    AR.loggedInUser().then((response) => {
      this.accounts = response.data.accounts;
      this.accountId = this.accounts[0].id;
    });
  },
};
</script>
